function ensureAccess(resourcesRequested) {
    return {user: ['userService', '$state', '$q', 'toastService','hasAccessTo', function (userService, $state, $q, toastService, hasAccessTo) {
        const d = $q.defer();
        userService.get().then(
            () => {
                if(resourcesRequested){
                    let hasAccess;
                    if(typeof resourcesRequested === 'string'){
                        hasAccess = hasAccessTo[resourcesRequested]();
                    }
                    else{
                        hasAccess = resourcesRequested.some((resource)=>{
                            return hasAccessTo[resource]();
                        });
                    }

                    if(hasAccess){
                        d.resolve(true);
                    }
                    else{
                        toastService.showActionToast("Du har ikke rettighet til dette.",  'Ok', {}, 0);
                        $state.go('loggedin');
                        d.reject();
                    }
                }
                else{
                    d.resolve(true);
                }
            },
            (err) => {
                if (!err) {
                    toastService.showSimpleToast("Brukeren er ikke logget inn", 3000);
                }
                $state.go('login');
            });
        return d.promise;
    }]}
}

const ensureLoggedOut = {isLoggedOut: ['userService','$state','$q', function (userService, $state, $q) {
    const d = $q.defer();
    userService.get()
        .then(() => $state.go('loggedin'),
            () => {d.resolve(true)});
    return d.promise;
}]};

rkcApp
    .constant('apiUrl','/api')
    .config(['$stateProvider','$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
        $urlRouterProvider.otherwise("/");
        $stateProvider
            .state('login', {
                url: "/login",
                template: "<rkc-header></rkc-header>" +
                "<rkc-login></rkc-login>",
                resolve: ensureLoggedOut
            })
            .state('loggedin', {
                url: "/",
                template: '<rkc-main class="bodies-little-div" layout="column" flex></rkc-main>',
                resolve: ensureAccess(null)
            })
            //--- Order Overview ----------------------------------
            .state('loggedin.orders', {
                url: "orders",
                template: "<rkc-orders></rkc-orders>",
                resolve: ensureAccess("orders"),
            })
            .state('loggedin.orders_orderdetails', {
                url: "orders/{orderNo}",
                template: "<rkc-order-details></rkc-order-details>",
                resolve: ensureAccess("orders")
            })
            //---------------------------------------------------
            .state('loggedin.lines', {
                url: "lines",
                template: "<rkc-lines></rkc-lines>",
                resolve: ensureAccess("orders")
            })
            .state('loggedin.lines.unconfirmed', {
                url: "/unconfirmed",
                template: "",
                resolve: ensureAccess("orders")
            })

            .state('loggedin.lines.deviation', {
                url: "/deviation",
                template: "",
                resolve: ensureAccess("orders")
            })
            .state('loggedin.articles', {
                url: "articles",
                template: "<rkc-articles></rkc-articles>",
                resolve: ensureAccess("orders"),
            })
            .state('loggedin.articles_articleprofile', {
                url: "articles/articleprofile/{articleNo}",
                template: "<rkc-articles-profile></rkc-articles-profile>",
                resolve: ensureAccess("orders")
            })
            .state('loggedin.users', {
                url: "users",
                template: "<rkc-users></rkc-users>",
                resolve: ensureAccess("administrate")
            })
            /*
            .state('loggedin.prognosis', {
                url: "prognosis",
                template: "<rkc-prognosis></rkc-prognosis>",
                resolve: ensureAccess("prognosis")
            })
            */

            .state('loggedin.parameters', {
                url: "parameters",
                template: "<rkc-parameters></rkc-parameters>",
                resolve: ensureAccess("administrate")
            })
            /*.state('loggedin.campaigns', {
                url: "campaigns",
                template: "<rkc-campaigns></rkc-campaigns>",
                resolve: ensureAccess("administrate")
            })*/
            /*
            .state('loggedin.notreceived', {
                url: "ordersnotreceived",
                template: "<rkc-not-received></rkc-not-received>",
                resolve: ensureAccess(["prognosis", "orders"])
            })
            */
            /*.state('loggedin.distributionKeys', {
                url: "distributionkeys",
                template: "<rkc-distribution-keys></rkc-distribution-keys>",
                resolve: ensureAccess("administrate")
            })*/
            .state('loggedin.expedition_booking_week', {
                url: "booking/week",
                template: "<rkc-booking></rkc-booking>",
                resolve: ensureAccess("expedition")
            })
            .state('loggedin.expedition_booking_day', {
                url: "booking/day",
                template: "<rkc-booking></rkc-booking>",
                resolve: ensureAccess("expedition")
            })
            .state('loggedin.error_list', {
                url: "errorlist",
                template: "<rkc-error-list></rkc-error-list>",
                resolve: ensureAccess("expedition")
            })
            .state('loggedin.error_list_detailed', {
                url: "errorlist/:id",
                template: "<rkc-error-list-detailed></rkc-error-list-detailed>",
                resolve: ensureAccess("expedition")
            })
            .state('loggedin.expedition_booking_bookingdetails', {
                url: "booking/details/:customerNo/:customerName/:date/:address/:chartererNo",
                template: "<rkc-booking-details></rkc-booking-details>",
                resolve: ensureAccess("expedition")
            })
            .state('loggedin.expedition_distribution_week', {
                url: "distribution/week",
                template: "<rkc-car></rkc-car>",
                resolve: ensureAccess("expedition")
            })
            .state('loggedin.expedition_distribution_day', {
                url: "distribution/day",
                template: "<rkc-car></rkc-car>",
                resolve: ensureAccess("expedition")
            })
            .state('loggedin.expedition_distribution_car', {
                url: "distribution/:date/:carName/:carId",
                template: "<rkc-customer></rkc-customer>",
                resolve: ensureAccess("expedition")
            })
            .state('loggedin.expedition_distribution_article_lines', {
                url: "distribution/:date/:carName/:carId/:customerId/:customerName/:shipmentId",
                template: "<rkc-article-lines></rkc-article-lines>",
                resolve: ensureAccess("expedition")
            })

            .state('loggedin.expedition_basicdata_items', {
                url: "items",
                template: "<rkc-items></rkc-items>",
                resolve: ensureAccess("expedition")
            })
            .state('loggedin.expedition_basicdata_items_itemdetails', {
                url: "items/detail/:itemId",
                template: "<rkc-item-details></rkc-item-details>",
                resolve: ensureAccess("expedition")
            })
            .state('loggedin.expedition_basicdata_locations', {
                url: "locations",
                template: "<rkc-locations></rkc-locations>",
                resolve: ensureAccess("expedition")
            })
            .state('loggedin.expedition_basicdata_locations_locationdetails', {
                url: "locations/detail/:locationId",
                template: "<rkc-location-details></rkc-location-details>",
                resolve: ensureAccess("expedition")
            })
            .state('loggedin.httpTriggers', {
                url: "reports",
                template: "<rkc-http-triggers></rkc-http-triggers>",
                resolve: ensureAccess("prognosis")
            })
    }])
;



/** WEBPACK FOOTER **
 ** ./src/app/stateConfig.ts
 **/